/* VitalSignsRow — 3-tile vital-signs grid (Next rain, Peak risk, Sunset).
 * Extracted from TodayPage. Shared between TodayPage and VerdictPage.
 */
import { motion } from "framer-motion";
import { CloudRain, Lightning, Moon, Sun } from "@phosphor-icons/react";
import { buildVitalSigns } from "@/components/v2/useVerdict";

export default function VitalSignsRow({ forecast, theme }) {
  const vitals = buildVitalSigns(forecast);

  return (
    <motion.div
      className="grid grid-cols-3 gap-2"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      data-testid="vital-signs"
    >
      <VitalTile
        theme={theme}
        Icon={vitals.nextRain.hasRain ? CloudRain : Sun}
        accent={vitals.nextRain.hasRain ? theme.accent : theme.textMuted}
        label="Next rain"
        value={vitals.nextRain.label}
        sub={vitals.nextRain.sub}
        testId="vital-next-rain"
      />
      <VitalTile
        theme={theme}
        Icon={Lightning}
        accent={
          vitals.peak.value == null
            ? theme.textMuted
            : vitals.peak.value < 30
              ? "#10b981"
              : vitals.peak.value < 60
                ? "#f59e0b"
                : "#ef4444"
        }
        label="Peak risk"
        value={vitals.peak.label}
        sub={vitals.peak.sub}
        testId="vital-peak-risk"
      />
      <VitalTile
        theme={theme}
        Icon={vitals.sun.isSet ? Sun : Moon}
        accent={theme.accent}
        label={vitals.sun.sub}
        value={vitals.sun.label}
        sub=""
        testId="vital-sun"
      />
    </motion.div>
  );
}

function VitalTile({ theme, Icon, accent, label, value, sub, testId }) {
  return (
    <div
      className="rounded-2xl px-2.5 py-2"
      style={{
        background: theme.surface,
        border: `1px solid ${theme.surfaceBorder}`,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
      data-testid={testId}
    >
      <div className="flex items-center gap-1 mb-0.5">
        <Icon size={11} weight="duotone" style={{ color: accent }} />
        <span
          className="text-[8.5px] font-bold uppercase tracking-[0.16em]"
          style={{ color: theme.textMuted }}
        >
          {label}
        </span>
      </div>
      <div
        className="font-display tabular-nums leading-none"
        style={{ fontSize: 17, fontWeight: 700, color: theme.textPrimary, letterSpacing: "-0.01em" }}
      >
        {value}
      </div>
      {sub && (
        <div className="text-[9.5px] mt-0.5" style={{ color: theme.textMuted }}>
          {sub}
        </div>
      )}
    </div>
  );
}
